<template>
	<div class='container'>
        <div class="province-box" v-for='(item,index) in treeData' :key='index'>
            <el-checkbox v-model="item.checkflag" @change="checkflagChange(item.code,index)"></el-checkbox>
            <el-popover
                placement="bottom"
                width="200"
                trigger="click">
                <div style="height:300px;overflow:auto">
                    <el-tree
                        ref='tree'
                        :data="item.child"
						v-if="isShowTree"
                        show-checkbox
                        node-key="code"
                        :default-checked-keys="checkedArr[item.code]"
                        @check='setCheckedKeys(index,item.code)'
                        :props="defaultProps">
                    </el-tree>
                </div>
                <span class="province-name" style="margin-left:3px" v-if="checkedArr[item.code].length > 0 && !item.checkflag" slot="reference">{{item.name + '('+checkedArr[item.code].length+')'}} <i class="el-icon-arrow-down"></i></span>
                <span v-else class="province-name" style="margin-left:3px" slot="reference">{{item.name}} <i class="el-icon-arrow-down"></i></span>
            </el-popover>
        </div>
        <div style="width:100%;height:30px;line-height: 30px;margin-bottom:10px">
            <el-checkbox :disabled="disabled" v-model="Allchecked" @change="allCheck">全选</el-checkbox>
            <el-button v-if='!disabled' size='mini' type='primary' @click="save" plain class="btn fx-btn">保存</el-button>
            <el-button v-if='!disabled' size='mini' plain class="btn fx-btn" @click="cancle">取消</el-button>
        </div>
	</div>

</template>
<script>
import { areaData } from '@/js/location/areaData.js'
import { childNode } from '@/js/location/childNode.js'
export default {
	name: 'tree',
	components: {
	},
	data () {
		return {
			isShowTree: true,
			childList: childNode,
			Allchecked: false,
			id: '',
			treeData: [],
			provinceList: [
				'110000',
				'120000',
				'130000',
				'140000',
				'150000',
				'210000',
				'220000',
				'230000',
				'310000',
				'320000',
				'330000',
				'340000',
				'350000',
				'360000',
				'370000',
				'410000',
				'420000',
				'430000',
				'440000',
				'450000',
				'460000',
				'500000',
				'510000',
				'520000',
				'530000',
				'540000',
				'610000',
				'620000',
				'630000',
				'640000',
				'650000',
				'710000',
				'810000',
				'820000',
				'900000'
			],
			checkedArr: {
				110000: [],
				120000: [],
				130000: [],
				140000: [],
				150000: [],
				210000: [],
				220000: [],
				230000: [],
				310000: [],
				320000: [],
				330000: [],
				340000: [],
				350000: [],
				360000: [],
				370000: [],
				410000: [],
				420000: [],
				430000: [],
				440000: [],
				450000: [],
				460000: [],
				500000: [],
				510000: [],
				520000: [],
				530000: [],
				540000: [],
				610000: [],
				620000: [],
				630000: [],
				640000: [],
				650000: []
			},
			checkedArrHalf: {
				110000: [],
				120000: [],
				130000: [],
				140000: [],
				150000: [],
				210000: [],
				220000: [],
				230000: [],
				310000: [],
				320000: [],
				330000: [],
				340000: [],
				350000: [],
				360000: [],
				370000: [],
				410000: [],
				420000: [],
				430000: [],
				440000: [],
				450000: [],
				460000: [],
				500000: [],
				510000: [],
				520000: [],
				530000: [],
				540000: [],
				610000: [],
				620000: [],
				630000: [],
				640000: [],
				650000: [] },
			defaultProps: {
				children: 'child',
				label: 'name'
			}
		}
	},
	props: {
		treeId: String,
		isAdd: Boolean,
		disabled: {
			type: Boolean,
			default: false
		},
		isCheckedArrHalf: Object,
		isCheckedArr: Object

	},
	created () {
		let list = areaData
		if (this.isAdd) {
			this.treeData = list
			this.checkAllSelect()
		} else {
			this.treeData = list
			if (this.treeId === '') {
				this.checkedArr = this.isCheckedArr
				this.checkedArrHalf = this.isCheckedArrHalf
				this.checkAllSelect()
			} else {
				this.get()
			}
		}
	},
	methods: {
		showTree () {
			this.isShowTree = true
		},
		hideTree () {
			this.isShowTree = false
		},
		checkAllSelect () {
			let list = this.treeData
			let j = 0
			for (let i = 0; i < list.length; i++) {
				if (list[i].count === this.checkedArr[list[i].code].length) {
					list[i].checkflag = true
				} else {
					list[i].checkflag = false
					j++
				}
			}
			if (j > 0) {
				this.Allchecked = false
			} else {
				this.Allchecked = true
			}
		},
		checkflagChange (code, index) {
			if (this.treeData[index].checkflag === true) {
				this.checkedArr[code] = this.childList[code]
				this.checkedArrHalf[code] = []
				this.isShowTree = false
				this.$nextTick(() => {
					this.checkAllSelect()
					this.isShowTree = true
				})
			} else {
				this.checkedArrHalf[code] = []
				this.checkedArr[code] = []
				this.isShowTree = false
				this.$nextTick(() => {
					this.checkAllSelect()
					this.isShowTree = true
				})
			}
		},
		allCheck () {
			let list = this.provinceList
			for (let i = 0; i < list.length; i++) {
				if (this.Allchecked === true) {
					this.checkedArr[list[i]] = this.childList[list[i]]
				} else {
					this.checkedArr[list[i]] = []
				}
			}
			this.$nextTick(() => {
				this.checkAllSelect()
			})
		},
		cancle () {
			this.$emit('dialogClose')
		},
		save () {
			let list = this.provinceList
			let checkArr = []
			let arr = []
			let flag = true
			let checkedArrHalf = []
			for (let i = 0; i < list.length; i++) {
				if (this.checkedArr[list[i]]) {
					if (this.checkedArr[list[i]].length > 0) {
						arr.push(list[i])
						flag = flag && false
					}
					checkArr = checkArr.concat(this.checkedArr[list[i]])
				}
				if (this.checkedArrHalf[list[i]]) {
					checkedArrHalf = checkedArrHalf.concat(this.checkedArrHalf[list[i]])
				}
			}
			if (flag) {
				this.$message.error('请选择配送区域')
				return false
			}
			let resData = {
				checkedArr: this.checkedArr,
				checkedArrHalf: this.checkedArrHalf,
				provinces: arr
			}
			this.$emit('addArea', resData)
		},
		get () {
			// let data = {
			// 	id: this.treeId
			// }
			// this.$store.dispatch('requestPost', {
			// 	url: `${this.$fxBaseApi.urlQIVShop}/freight/area/get`,
			// 	data: data
			// }).then(res => {
			// console.log(this.isCheckedArr)
			let list = this.isCheckedArr
			let list1 = this.isCheckedArrHalf
			let provinceList = this.provinceList
			for (let i = 0; i < provinceList.length; i++) {
				if (list[provinceList[i]]) {
					this.checkedArr[provinceList[i]] = list[provinceList[i]]
				}
				if (list1[provinceList[i]]) {
					this.checkedArrHalf[provinceList[i]] = list1[provinceList[i]]
				}
			}
			this.$nextTick(() => {
				this.checkAllSelect()
			})
			// })
		},
		setCheckedKeys (index, code) {
			var a =	this.$refs.tree[index].getCheckedKeys()
			var b = this.$refs.tree[index].getHalfCheckedKeys()
			this.checkedArr[code] = a
			this.checkedArrHalf[code] = b
			if (this.checkedArr[code].length === this.treeData[index].count) {
				this.treeData[index].checkflag = true
			} else {
				this.treeData[index].checkflag = false
			}
			this.$nextTick(() => {
				this.checkAllSelect()
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
    .container{
        display :flex;
        flex-direction:row;
        flex-wrap:wrap
        .province-box{
            width :24%;
            height :40px;
            .province-name{
                cursor pointer
            }
        }
        .btn{
            float:right;
            margin-left:10px;
        }
	}

</style>
<style lang="stylus">
.permissions {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
